module.exports = __webpack_public_path__ + "static/media/logo-ginssen.48cb664c.png";